export default __webpack_public_path__ + "static/media/getting-started-1.031bd44b.png";